import { useState, useEffect } from 'react';
import { getSlots } from '../config/apiConfig';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/es';
moment.locale('es');

const useWeek = (initialStart = moment()) => {
  const [start, setStart] = useState(initialStart);
  const [slots, setSlots] = useState([]);
  const [week, setWeek] = useState({
    start: moment(initialStart), end: moment(initialStart).add(7, 'days')
  });

  useEffect(() => {
    setWeek({ start: moment(start), end: moment(start).add(7, 'days') });
    getSlots(moment(start).format('L'))
      .then(res => setSlots(res.data.slots))
      .catch(err => console.error(err));
  }, [start]);

  const prevWeek = () => {
    if (moment().isSameOrBefore(moment(start).subtract(7, 'days'), 'days'))
      setStart(start => moment(start).subtract(7, 'days'));
  };

  const nextWeek = () => setStart(start => moment(start).add(7, 'days'));

  return {
    week,
    slots,
    prevWeek,
    nextWeek
  };
};

export default useWeek;